<template>
  <div class="major-shareholders-details">
    <component :is="component" />
  </div>
</template>

<script>
import MajorShareholdersDetailsHk from './MajorShareholdersDetailsHk.vue'
import MajorShareholdersDetailsUs from './MajorShareholdersDetailsUs.vue'
import MajorShareholdersDetailsHs from './MajorShareholdersDetailsHs.vue'

const components = {
  hk: MajorShareholdersDetailsHk,
  hs: MajorShareholdersDetailsHs,
  us: MajorShareholdersDetailsUs
}
export default {
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    component() {
      return components[this.market]
    }
  }
}
</script>

<style>
.major-shareholders-details {
  height: calc(100vh - 48px);
  background: var(--bg-color-2);
}
</style>
